import {
    getTripDetailsInRealTime,getTrackRealTimeTripApi
} from "../../helpers/backend_helper";

import {
    getTripList,
    setLoading,
    errorMessages,
    setTrackData
} from "./reducer";

export const getAllTripsRealTimeList = () => async (dispatch) => {
    try {
        dispatch(setLoading({ key: "tripList", value: true }));
        const response = await getTripDetailsInRealTime();
        dispatch(getTripList(response));
    } catch (error) {
        console.error("Error fetching trip list:", error);
        dispatch(errorMessages("Something went wrong while fetching trips."));
    } finally {
        dispatch(setLoading({ key: "tripList", value: false }));
    }
};

export const fetchTrackRealTimeTrip = (from, to, id , tripId) => async (dispatch) => {
    try {
        dispatch(setLoading({ key: "trackData", value: { [tripId]: true } }));      
          const response = await getTrackRealTimeTripApi(from, to, id);        
        dispatch(setTrackData({ tripId, data: response }));
        return response;
    } catch (error) {
        const message = error?.response?.data?.errors || "Failed to load trip dashboard.";
        return false;
    } finally {
        dispatch(setLoading({ key: "trackData", value: { [tripId]: false } }));    }
};